/* Candela product cards — navigation for the [data-href] blocks (media + info) and
   prefetch of the product page's first image (in product-page size)
   on hover / touchstart / focus so the image is already cached when the card is clicked.
   Uses an off-DOM <img> with the same srcset + sizes as the product page, so the browser
   resolves the exact same candidate URL for this viewport and DPR. */

(function () {
  var done = new WeakSet();

  function prefetch(card) {
    if (done.has(card)) return;
    done.add(card);

    var srcset = card.dataset.pdpSrcset;
    var sizes = card.dataset.pdpSizes;
    if (!srcset) return;

    var conn = navigator.connection;
    if (conn && (conn.saveData || /2g/.test(conn.effectiveType || ''))) return;

    var img = new Image();
    img.decoding = 'async';
    if (sizes) img.sizes = sizes;
    img.srcset = srcset;
  }

  function onEnter(e) {
    var card = e.target.closest && e.target.closest('.candela-card[data-pdp-srcset]');
    if (card) prefetch(card);
  }

  document.addEventListener('mouseover', onEnter, { passive: true });
  document.addEventListener('touchstart', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter, { passive: true });
})();

/* Card navigation: media/info blocks are not anchors (no status-bar URL on hover) */
(function () {
  function go(el, e) {
    var href = el.dataset.href;
    if (!href) return;
    if (e.metaKey || e.ctrlKey || e.button === 1) {
      window.open(href, '_blank', 'noopener');
    } else {
      window.location.href = href;
    }
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('.candela-card__quick-add-btn, .candela-card__apparel')) return;
    var el = e.target.closest('.candela-card [data-href]');
    if (el) go(el, e);
  });

  document.addEventListener('auxclick', function (e) {
    if (e.button !== 1) return;
    var el = e.target.closest('.candela-card [data-href]');
    if (el) { e.preventDefault(); go(el, e); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    var el = e.target.closest && e.target.closest('.candela-card [data-href][role="link"]');
    if (el) { e.preventDefault(); go(el, e); }
  });
})();
